<template>
  <div id="top" class="top">
    <Header isHome="true" />
    <div class="container">
      <section class="contents-intro">
        <h1><img src="@/assets/images/title-brand-guidelines.svg" alt="Brand Guidelines" class="pc">
          <img src="@/assets/images/title-brand-guidelines-wrap.svg" alt="Brand Guidelines" class="sp">
          <span>ノバセルのブランドガイドライン</span>
        </h1>
        <div class="intro-mask">
          <p>
          ここには最新のロゴファイルがアップされてます。<br>
          ダウンロードしてご利用ください。<br>
          ノバセルのロゴを利用する場合<br>
          許諾を得る必要があります。<br>
          </p>
        </div>
        <Button url="https://docs.google.com/forms/d/e/1FAIpQLScQKIAPgi2N84JcC0lONyXd8DlpoiDSsYuFeYMLX8vUinLsIw/viewform" target="_blank" class="intro-transition">使用許諾をリクエスト</Button>
      </section>
      <div class="lottie-container">
        <div id="novasell" ref="novasell" class="novasell"></div>
      </div>
      <SectionPrimary headline="連続成長と非連続成長" align="center">
        <template v-slot:contents>
          <p>テレビCMを通して事業成長を実現するという思いを込めて<br>
          ノバセルのマークはテレビCMが生み出す<br>
          「事業の連続成長と非連続成長」を象徴しています
          </p>
        </template>
      </SectionPrimary>
      <div class="growth-container">
        <div id="growth" ref="growth" class="growth"></div>
      </div>
      <div class="normal-contents">
        <SectionPrimary headline="コンセプト" align="center">
          <template v-slot:contents>
            <p>ノバセルアイデンティティのコンセプトは「事業を伸ばせる」です<br>
            それは4つの鍵となる要素から構成されています
            </p>
            <img src="@/assets/images/top-concept.svg" class="image-concept">
          </template>
        </SectionPrimary>
      </div>
      <SectionPrimary headline="ロゴ利用時に気をつけて欲しいこと" align="center">
        <template v-slot:contents>
          <p>統一感を作るためには<br>
          小さな積み重ねが大事です。<br>
          利用するときに気をつけて欲しいことを<br>
          まとめました。
          </p>
        </template>
      </SectionPrimary>
      <div class="secondary-contents normal-contents">
        <SectionSecondary headline="フルカラーか白抜き、どちらかをどうぞ。" align="left">
          <template v-slot:lead>背景色に合わせてフルカラーか、白抜きのどちらかを選択してください。</template>
          <template v-slot:contents>
            <BrandExample img="logo-example-3.svg" />
          </template>
        </SectionSecondary>
        <SectionSecondary headline="元のまま、ご利用ください。" align="left" columns="two-columns">
          <template v-slot:lead>色を変えたり、変形したりしないでください。</template>
          <template v-slot:contents>
            <BrandExample img="logo-example-4.svg" ngHeadline="色を変えないでください" />
            <BrandExample img="logo-example-5.svg" ngHeadline="配置のバランスを変えないでください" />
            <BrandExample img="logo-example-6.svg" ngHeadline="目立たせたるためでも他の色にしないでください" />
            <BrandExample img="logo-example-7.svg" ngHeadline="画像の縦横比率を変えないでください" />
            <BrandExample img="logo-example-8.svg" ngHeadline="印刷仕様の制限以外の理由で色を黒にしないでください" />
            <BrandExample img="logo-example-9.svg" ngHeadline="勢いを出したくても3Dにしないでください" />
          </template>
        </SectionSecondary>
        <SectionSecondary headline="背景色は見やすくなるように。" align="left" columns="two-columns">
          <template v-slot:lead>
            背景色とコントラストが弱いと、見づらくなります。<br>
            ロゴが映えるように、はっきりとした色使いをすると効果的です。
          </template>
          <template v-slot:contents>
            <BrandExample img="logo-example-10.svg" okHeadline="フルカラーに対して、背景色が十分に薄い" />
            <BrandExample img="logo-example-11.svg" ngHeadline="背景が微妙に濃いので、見辛い" />
            <BrandExample img="logo-example-12.svg" okHeadline="白抜きに対して、背景色が十分に濃い" />
            <BrandExample img="logo-example-13.svg" ngHeadline="背景が薄いので、見辛い" />
          </template>
        </SectionSecondary>
        <SectionSecondary headline="周りに余白を作ってください。" align="left" columns="two-columns">
          <template v-slot:lead>
            他の要素を近づけすぎないでください。雰囲気が壊れてしまうのです。<br>
            目安はマークの1辺の75%分。
          </template>
          <template v-slot:contents>
            <BrandExample img="logo-example-14.svg" class="big-column"/>
            <BrandExample img="logo-example-15.svg" ngHeadline="近すぎる" />
            <BrandExample img="logo-example-16.svg" ngHeadline="近すぎる" />
            <BrandExample img="logo-example-17.svg" ngHeadline="重ねてしまっている" />
            <BrandExample img="logo-example-18.svg" ngHeadline="ブランドカラーに関係ない色だし、重ねてしまっている" />
          </template>
        </SectionSecondary>
        <SectionSecondary headline="最小サイズに気をつけてください。潰れてしまいます。" align="left" columns="two-columns">
          <template v-slot:lead>
            小さすぎると、解像度の荒いモニターで潰れてしまうことがあります。
          </template>
          <template v-slot:contents>
            <BrandExample img="logo-example-19.svg" okHeadline="高さが32px以上ある" />
            <BrandExample img="logo-example-20.svg" ngHeadline="高さが32px未満" />
          </template>
        </SectionSecondary>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../Molecules/Header'
import Footer from '../Molecules/Footer'
import Button from '../Atoms/Button'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SectionPrimary from '../Organisms/SectionPrimary'
import SectionSecondary from '../Organisms/SectionSecondary'
import Lottie from 'lottie-web'
import BrandExample from '../Molecules/BrandExample'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'Top',
  data () {
    return {
      animNovasell: null,
      animGrowth: null
    }
  },
  components: {
    Header,
    Footer,
    Button,
    SectionPrimary,
    SectionSecondary,
    BrandExample
  },
  mounted: function () {
    this.animGrowth = Lottie.loadAnimation({
      container: this.$refs.growth,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: './static/growth.json'
    })
    this.animNovasell = Lottie.loadAnimation({
      container: this.$refs.novasell,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: './static/top.json'
    })
    this.scrollItemA()
  },
  methods: {
    scrollItemA: function () {
      ScrollTrigger.create({
        trigger: '.growth-container',
        start: 'top 80%',
        end: 'bottom top',
        markers: false,
        scrub: false,
        onEnter: this.playGrowth
      })
    },
    playGrowth: function () {
      this.animGrowth.play()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  width: 100%;
}

.contents-intro {
  width: 100%;
  margin: 0 auto;
  padding: 14.4rem 14.4rem 0;
  text-align: left;
  box-sizing: border-box;
  position: relative;
  z-index: 3;
}

@media screen and (max-width: 1440px) {
  .contents-intro {
    padding: 14.4rem 9.6rem 0;
  }
}

@media screen and (max-width: 1024px) {
  .contents-intro {
    padding: 14.4rem 7.2rem 0;
  }
}

@media screen and (max-width: 700px) {
  .contents-intro {
    margin-bottom: 0;
  }
}

.normal-contents {
  margin: 0 14.4rem;
}

@media screen and (max-width: 1440px) {
  .normal-contents {
    margin: 0 9.6rem ;
  }
}

@media screen and (max-width: 1024px) {
  .normal-contents {
    margin: 0 7.2rem;
  }
}

@media screen and (max-width: 700px) {
  .normal-contents {
    margin: 0 4.8rem;
  }
}

.secondary-contents {
  background: var(--snow);
  border-radius: 1.2rem;
}

.contents-intro p {
  animation: intro-headline 0.3s;
  animation-delay: 1s;
  animation-fill-mode: backwards;
}

h1 {
  overflow: hidden;
  font-size: var(--extra-jumbo-font-size);
  line-height: 1.5;
  margin-bottom: 3.2rem;
  font-weight: var(--bold-font-weight);
}

@media screen and (max-width: 1024px) {
  h1 {
    font-size: var(--jumbo-font-size);
    margin-bottom: 1.6rem;
  }
}

h1 img {
  width: 100%;
  max-width: 103.2rem;
  height: auto;
  animation: intro-headline 0.3s;
  animation-delay: 0.8s;
  animation-fill-mode: backwards;
}

h1 img.sp {
  display: none;
}

@media screen and (max-width: 1024px) {
h1 img.sp {
  display: block;
  width: auto;
  max-height: 22rem;
}
h1 img.pc {
  display: none;
}
}

h1 span {
  margin: 4.8rem 0 1.2rem;
  font-size: var(--extra-jumbo-font-size);
  font-weight: var(--bold-font-weight);
  display: block;
  animation: intro-headline 0.3s;
  animation-delay: 0.9s;
  animation-fill-mode: backwards;
}

@media screen and (max-width: 1024px) {
  h1 span {
    font-size: var(--jumbo-font-size);
    margin: 4.8rem 0 1.2rem;
  }
}

p {
  font-size: var(--normal-font-size);
  line-height: 2.5;
  margin-bottom: 4.8rem;
}

.intro-mask {
  overflow: hidden;
}

@keyframes intro-headline {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0%);
  }
}

.lottie-container {
  position: relative;
  margin-top: -70rem;
  margin-bottom: -24rem;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  z-index: 2;
}

@media screen and (max-width: 1024px) {
  .lottie-container {
    margin-top: -48vw;
    margin-bottom: -20vw;
    min-height: 60vh;
  }
}

.novasell {
  width: 170vw;
  height: auto;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

@media screen and (max-width: 1024px) {
  .novasell {
    width: 212vw;
  }
}

.lottie {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.intro-transition {
  animation: intro-button 0.3s;
  animation-delay: 1.1s;
  animation-fill-mode: backwards;
}

@keyframes intro-button {
  0% {
    opacity: 0;
    transform: translateY(50%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
.growth-container {
  position: relative;
  z-index: 1;
}
.growth {
  width: 100%;
  height: auto;
}

.image-concept {
  width: 100%;
  max-width: 144rem;
}

.big-column {
  grid-column-start: 1;
  grid-column-end: 3;
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/Top.vue